/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewsletterLocation
 */
export interface NewsletterLocation {
    /**
     * 
     * @type {string}
     * @memberof NewsletterLocation
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof NewsletterLocation
     */
    offers: Array<number>;
}

export function NewsletterLocationFromJSON(json: any): NewsletterLocation {
    return NewsletterLocationFromJSONTyped(json, false);
}

export function NewsletterLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewsletterLocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'offers': json['offers'],
    };
}

export function NewsletterLocationToJSON(value?: NewsletterLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'offers': value.offers,
    };
}


